import {ReefResource} from "../../client/resources/reefResource";

type ReefDisplayLabelInput = Pick<ReefResource, "Name" | "DisplayName">;

export function reefDisplayLabel(reefInput: ReefDisplayLabelInput): string {
    const displayNameRequired = reefInput.Name != reefInput.DisplayName
    return displayNameRequired 
        ? `${reefInput.DisplayName} (${reefInput.Name})`
        : reefInput.Name
}